module.exports = __webpack_public_path__ + "img/rightcalf-ectomorph-female.53aa55e7.svg";